<template>
    <div class="relative">
        <div @click="open = ! open">
            <slot name="trigger"></slot>
        </div>
        <transition enter-active-class="transition ease-out duration-300"
                    enter-from-class="transform opacity-0"
                    enter-to-class="transform opacity-100"
                    leave-active-class="transition ease-in duration-150"
                    leave-from-class="transform opacity-100"
                    leave-to-class="transform opacity-0">
            <div v-show="open">
                <slot name="content"/>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "Collapsable",
    data() {
        return {
            open: false,
        };
    },
}
</script>

<style scoped>

</style>
